import Cookies from "js-cookie";

import { isMobile, getNumberId } from "../common/utils";

import Wishlist from "../common/wishlist";
const wishlist = Wishlist();

const SPEEDSIZE_PREFIX = "https://sfycdn.speedsize.com/a0aebe60-8b13-4e95-8aca-b006a78ac89f/";

const renderProductCard = (
  productId,
  _variantId,
  handle,
  imageUrl,
  hoverImageUrl,
  vendor,
  title,
  price,
  hasPriceRange,
  compareAtPrice,
  salesTypes,
  inventory,
  tags,
  algoliaParams,
) => {
  const w = isMobile() ? 480 : 640;
  let ssImageUrl = `${SPEEDSIZE_PREFIX}${imageUrl}&width=${w}`;

  let hoverImg = "";
  if (hoverImageUrl && !isMobile()) {
    hoverImg = `<img class="fs-hover-image" src="${SPEEDSIZE_PREFIX}${hoverImageUrl}&width=${w}" loading="lazy" width="${w}" height="${(w / 4) * 5}" />`;
  }

  let priceText = `<span class="fs-price">&yen; ${new Intl.NumberFormat("ja-JP").format(price)}${hasPriceRange ? "〜" : ""}</span>`;
  if (compareAtPrice && price != compareAtPrice) {
    let discountRate = (100.0 - (price / compareAtPrice) * 100.0).toString().split(".")[0];
    priceText += ` <span class="fs-discount-rate">(${discountRate}%OFF)</span>`;
  }

  let algoliaAttrs = "";
  if (algoliaParams) {
    algoliaAttrs = `
      data-algolia-index="${algoliaParams.searchIndexName}"
      data-algolia-query-id="${algoliaParams.queryId}"
      data-algolia-position="${algoliaParams.position}"
      data-algolia-object-id="${algoliaParams.objectId}"
    `;
  }

  let soldout = false;
  if (!tags.includes("coming soon") && !tags.includes("COMING SOON") && inventory == 0) {
    soldout = true;
  }

  return `
    <div class="fs-product-card" data-product-id="${productId}" ${algoliaAttrs}>
      <a href="/products/${handle}">
        <div class="fs-images">
          ${hoverImg}
          <img
             class="fs-image ${hoverImageUrl ? "fs-has-hover" : ""}" src="${ssImageUrl}" loading="lazy" alt="${title}"
             width="${w}" height="${(w / 4) * 5}" />
        </div>
      </a>
      <div class="fs-info">
        <a href="/products/${handle}">
          <p class="fs-vendor">${vendor}</p>
          <p class="fs-name">${title}</p>
          <p class="fs-price-row">${priceText}</p>
        </a>
      <div class="fs-row">
        <button class="fs-wishlist-button" data-product-id="${productId}"></button>
        <div class="fs-badges">
          ${tags.includes("クーポン対象") ? '<div class="fs-badge sale">クーポン対象</div>' : ""}
          ${tags.includes("キャンペーン対象") ? '<div class="fs-badge sale">キャンペーン対象</div>' : ""}
          ${salesTypes.includes("予約商品") ? '<div class="fs-badge presale">予約商品</div>' : ""}
          ${tags.includes("再入荷") ? '<div class="fs-badge restock">再入荷</div>' : ""}
          ${tags.includes("coming soon") || tags.includes("COMING SOON") ? '<div class="fs-badge sale">COMING SOON</div>' : ""}
          ${tags.includes("新着商品") ? '<div class="fs-badge sale">新着商品</div>' : ""}
          ${inventory == 1 ? '<div class="fs-badge stock">残り1点</div>' : ""}
          ${soldout ? '<div class="fs-badge soldout">SOLD OUT</div>' : ""}
          ${tags.includes("洗える") ? '<div class="fs-badge presale">洗える</div>' : ""}
          ${tags.includes("記事掲載") ? '<div class="fs-badge presale">記事掲載</div>' : ""}
          ${tags.includes("スナップ着用") ? '<div class="fs-badge presale">スナップ着用</div>' : ""}
          ${tags.includes("コラボアイテム") ? '<div class="fs-badge presale">コラボアイテム</div>' : ""}
          ${tags.includes("別注アイテム") ? '<div class="fs-badge presale">別注アイテム</div>' : ""}
          ${tags.includes("自宅試着OK") ? '<div class="fs-badge sale">自宅試着OK</div>' : ""}
          ${tags.includes("セットアップ割") ? '<div class="fs-badge sale">セットアップ割</div>' : ""}
          ${tags.includes("セットアップ") ? '<div class="fs-badge presale">セットアップ</div>' : ""}
        </div>
      </div>
    </div>
        </div>
  `;
  /* ${salesTypes.includes('セール商品') ? '<div class="fs-badge sale">SALE</div>' : ''}   */
};

const renderAlgoliaProduct = (product, searchIndexName, queryId) => {
  let image = product.image;
  let hoverImage = product.product_image;
  if (!image) {
    image = product.product_image;
  }

  let hasPriceRange = false;
  let price = product.price;
  let compareAtPrice = product.compare_at_price;
  if (
    product.variants_min_price &&
    0 < product.variants_min_price &&
    product.variants_min_price != product.variants_max_price
  ) {
    hasPriceRange = true;
    price = product.variants_min_price;
    compareAtPrice = product.variants_compare_at_price_min;
  }

  let salesTypes = [];
  if (product.meta && product.meta.custom && product.meta.custom.sales_type) {
    salesTypes = product.meta.custom.sales_type;
  }

  const algoliaParams = {
    searchIndexName: searchIndexName,
    queryId: queryId,
    position: product.position,
    objectId: product.objectID,
  };

  return renderProductCard(
    product.id,
    product.objectID,
    product.handle,
    image,
    hoverImage,
    product.vendor,
    product.title,
    price,
    hasPriceRange,
    compareAtPrice,
    salesTypes,
    product.variants_inventory_count,
    product.tags,
    algoliaParams,
  );
};

const renderShopifyProduct = (product, color = null) => {
  let variant = product.variants.nodes[0];
  if (color) {
    variant = product.variants.nodes.find((node) => {
      const option = node.selectedOptions.find((o) => o.name == "色");
      if (!option) {
        return false;
      }
      return option.value == color;
    });
  }
  let quantity = product.totalInventory;
  if (variant && color) {
    let vq = 0;
    product.variants.nodes.forEach((node) => {
      const option = node.selectedOptions.find((o) => o.name == "色");
      if (option && option.value == color) {
        vq += node.quantityAvailable;
      }
    });
    quantity = vq;
  }

  const productId = getNumberId(product.id);
  const variantId = getNumberId(product.variants.nodes[0].id);

  let image = "";
  let hoverImage = "";
  if (!color || !variant) {
    image = product.images?.edges?.[0]?.node.url; //?.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + 'grande' + '.$2')
    let index = product.hover_image !== null ? parseInt(product.hover_image.value) : 2;
    if (!index || !product.images?.edges?.[index - 1]?.node) {
      index = 2;
    }
    hoverImage = product.images?.edges?.[index - 1]?.node.url; //?.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + 'grande' + '.$2')
  } else {
    image = variant.image.url;
    hoverImage = product.images?.edges?.[1]?.node.url; //?.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + 'grande' + '.$2')
  }

  let compareAtPrice = !product.compareAtPriceRange
    ? null
    : parseInt(product.compareAtPriceRange.minVariantPrice.amount);
  const salesTypes = !product.sales_type ? [] : product.sales_type.value.split(",");

  return renderProductCard(
    productId,
    variantId,
    product.handle,
    image,
    hoverImage,
    product.vendor,
    product.title,
    product.priceRange.minVariantPrice.amount,
    product.priceRange.minVariantPrice.amount != product.priceRange.maxVariantPrice.amount,
    compareAtPrice,
    salesTypes,
    quantity,
    product.tags,
    null,
  );
};

const addHoverImage = (container, product) => {
  const productId = getNumberId(product.id);
  let imageIndex = product.hover_image !== null ? parseInt(product.hover_image.value) : 2;
  if (!imageIndex || !product.images?.edges?.[imageIndex - 1]?.node) {
    imageIndex = 2;
  }
  const hoverImage = product.images?.edges?.[imageIndex - 1]?.node;
  if (!hoverImage) {
    return;
  }
  const images = container.querySelector(`.fs-product-card[data-product-id="${productId}"] .fs-images`);
  const image = images.querySelector(".fs-image");
  image.classList.add("fs-has-hover");

  const hoverImg = document.createElement("img");
  hoverImg.src = hoverImage.url; // .replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + 'grande' + '.$2')
  hoverImg.width = hoverImage.width;
  hoverImg.height = hoverImage.height;
  hoverImg.classList.add("fs-hover-image");
  images.insertBefore(hoverImg, image);
};

const addClickedObjectIDsAfterSearch = (container, searchInsights) => {
  container.querySelectorAll(".fs-product-card").forEach((productCard) => {
    productCard.querySelectorAll("a").forEach((a) => {
      a.addEventListener("click", (e) => {
        let userToken = Cookies.get("algoliaUserToken");
        if (!userToken) {
          userToken = "user-" + uuidv4();
          Cookies.set("algoliaUserToken", userToken, { expires: 180 });
        }
        searchInsights("clickedObjectIDsAfterSearch", {
          userToken: userToken,
          eventName: "click",
          index: productCard.dataset.algoliaIndex,
          queryID: productCard.dataset.algoliaQueryId,
          objectIDs: [productCard.dataset.algoliaObjectId],
          positions: [parseInt(productCard.dataset.algoliaPosition)],
        });
      });
    });
  });
};

const wishlistButtonListener = (e) => {
  const button = e.target;
  wishlist.toggleWishlist(parseInt(button.dataset.productId));
};

const addWishlistButtonListener = (container) => {
  if (!window._swat) {
    setTimeout(() => {
      addWishlistButtonListener(container);
    }, 200);
    return;
  }
  container.querySelectorAll(".fs-wishlist-button").forEach((button) => {
    button.removeEventListener("click", wishlistButtonListener);
    button.addEventListener("click", wishlistButtonListener);
  });
};

const ProductCardRenderer = () => {
  return {
    renderAlgoliaProduct: renderAlgoliaProduct,
    renderShopifyProduct: renderShopifyProduct,
    addHoverImage: addHoverImage,
    addClickedObjectIDsAfterSearch: addClickedObjectIDsAfterSearch,
    addWishlistButtonListener: addWishlistButtonListener,
  };
};

export default ProductCardRenderer;
